module.exports = __webpack_public_path__ + "static/media/BARKH_WM_WHITE.eab8d3b1.svg";